<template>
    <div class="user-record">
        <div v-if="giftRecord.length" class="">
            <p class="record-title">获得礼物</p>
            <ul class="gift-list">
                <li v-for="giftItem in giftRecord" :key="giftItem.id" class="gift-item">
                    <img :src="giftItem.cover" class="gift-item-img"/>
                    <div class="gift-item-foot">
                        <span class="gift-label">{{giftItem.name}}</span>
                        <span class="gift-num">x{{ giftItem.num }}</span>
                    </div>
                </li>
            </ul>
        </div>

        <div class="record-flex">
            <div class="record-container">
                <p class="record-title">通关记录</p>
                <ul class="record-list">
                    <li v-for="record in recordList" :key="record.id" class="record-item">
                        {{ record.reason }}
                    </li>
                </ul>
            </div>
            <div class="record-container">
                <p class="record-title">商城记录</p>
                <ul class="record-list">
                    <li v-for="(record, index) in mallRecordList" :key="index" class="record-item">
                        {{ record }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import AccountModel from "@/models/account"
import { apiGetReceivedGifts, apiGetUserUseRecord } from '@/models/mall'

const account = new AccountModel()

export default {
    name: "UserRecord",
    data() {
        return {
            giftRecord: [],
            recordList: [],
            mallRecordList: [],
        }
    },
    methods: {
        // 获取礼物记录
        async getGiftRecord() {
            const res = await apiGetReceivedGifts()
            this.giftRecord = res.data
        },
        // 获取闯关等记录
        async getNormalRecordList() {
            const res = await account.list({
                type: 'COIN',
            })
            this.recordList = res.data.filter(item => item.type ===1)
        },
        // 获取商城记录
        async getMallRecordList() {
            const res = await apiGetUserUseRecord()
            this.mallRecordList = res.data.items || []
        },
    },
    created() {
        this.getGiftRecord()
        this.getNormalRecordList()
        this.getMallRecordList()
    },
}
</script>

<style scoped>
.user-record {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 24px;
    overflow: auto;
    text-align: left;
}
.user-record::-webkit-scrollbar {
    display: none;
}
.record-title {
    padding: 0 0 16px;
    margin: 0;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
    text-indent: 12px;
}

.gift-list {
    display: flex;
    gap: 24px;
    padding: 0;
    margin: 0;
    margin-bottom: 24px;
    overflow: auto
}
.gift-list::-webkit-scrollbar {
    display: none;
}
.gift-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: 152px;
    height: 173px;
    background: #fff3d3;
    border-radius: 23px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset; 
}
.gift-item-img {
    width: 96px;
    height: 96px;
    margin-top: 20px;
}
.gift-item-foot {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
}
.gift-label {
    font-size: 20px;
    font-weight: bold;
    color: #6F6C68;
}
.gift-num {
    margin-left: 8px;
    font-size: 24px;
    font-weight: bold;
    color: #8BB91C;
}

.record-flex {
    display: flex;
    gap: 24px;
}
.record-container {
    flex: 1;
    flex-shrink: 0;
}
.record-list {
    height: 210px;
    padding: 24px 20px;
    margin: 0;
    background: #fff3d3;
    border-radius: 23px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset; 
    list-style: none;
    overflow: auto;
}
.record-list::-webkit-scrollbar {
    display: none;
}
.record-item {
    padding: 8px 0;
    font-size: 20px;
    font-weight: bold;
    color: #6F6C68;
}
</style>